export default __webpack_public_path__ + "static/media/me4.41f8937d.gif";